import React from 'react';
import { Calendar, BookOpen, ArrowRight } from 'lucide-react';
export function BookingSection() {
  return <section className="w-full max-w-[900px] mx-auto py-20 px-4 animate-fadeIn" data-id="element-47">
      {/* Header */}
      <div className="text-center space-y-4 mb-12" data-id="element-48">
        <div className="inline-block px-3 py-1 rounded-full border border-[#C89B40]/30 bg-[#C89B40]/5 text-[#C89B40] text-xs tracking-widest uppercase mb-2" data-id="element-49">
          Paso 03
        </div>
        <h2 className="text-3xl md:text-4xl font-serif text-[#F5EDE0]" data-id="element-50">
          Profundiza en tu Camino
        </h2>
        <p className="text-sm md:text-base text-[#d9cec0]/70 max-w-lg mx-auto leading-relaxed" data-id="element-51">
          Si buscas una guía más personalizada o deseas aprender a leer las
          cartas por ti mismo, reserva una sesión privada.
        </p>
      </div>

      {/* Pricing Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-52">
        {/* Card 1: Clase de Tarot */}
        <div className="group relative" data-id="element-53">
          <div className="absolute -inset-0.5 bg-gradient-to-b from-[#C89B40]/20 to-[#C89B40]/5 rounded-2xl blur opacity-50 group-hover:opacity-100 transition duration-500" data-id="element-54"></div>
          <div className="relative h-full bg-[#0C0A09] border border-[#C89B40]/20 rounded-2xl p-8 flex flex-col items-center text-center hover:border-[#C89B40]/40 transition-colors duration-300" data-id="element-55">
            <div className="w-12 h-12 rounded-full bg-[#C89B40]/10 flex items-center justify-center mb-6 text-[#C89B40]" data-id="element-56">
              <BookOpen className="w-6 h-6" data-id="element-57" />
            </div>

            <h3 className="text-xl font-serif text-[#F5EDE0] mb-2" data-id="element-58">
              Clase de Tarot
            </h3>
            <p className="text-xs text-[#d9cec0]/60 uppercase tracking-widest mb-6" data-id="element-59">
              Aprendizaje Individual
            </p>

            <div className="flex items-baseline justify-center gap-1 mb-6" data-id="element-60">
              <span className="text-4xl font-light text-[#C89B40]" data-id="element-61">99€</span>
              <span className="text-sm text-[#d9cec0]/50" data-id="element-62">/ sesión</span>
            </div>

            <p className="text-sm text-[#d9cec0]/80 leading-relaxed mb-8 flex-grow" data-id="element-63">
              Aprende a interpretar los arcanos y desarrolla tu intuición en una
              clase privada diseñada a tu medida. Ideal para principiantes o
              avanzados.
            </p>

            <button className="w-full py-3 px-6 rounded-full bg-[#C89B40]/10 border border-[#C89B40]/30 text-[#C89B40] text-sm font-semibold tracking-wide hover:bg-[#C89B40] hover:text-[#0C0A09] transition-all duration-300 flex items-center justify-center gap-2 group-hover:translate-y-[-2px]" data-id="element-64">
              <span data-id="element-65">Reservar Clase</span>
              <ArrowRight className="w-4 h-4" data-id="element-66" />
            </button>
          </div>
        </div>

        {/* Card 2: Lectura Personal */}
        <div className="group relative" data-id="element-67">
          <div className="absolute -inset-0.5 bg-gradient-to-b from-[#C89B40]/20 to-[#C89B40]/5 rounded-2xl blur opacity-50 group-hover:opacity-100 transition duration-500" data-id="element-68"></div>
          <div className="relative h-full bg-[#0C0A09] border border-[#C89B40]/20 rounded-2xl p-8 flex flex-col items-center text-center hover:border-[#C89B40]/40 transition-colors duration-300" data-id="element-69">
            <div className="w-12 h-12 rounded-full bg-[#C89B40]/10 flex items-center justify-center mb-6 text-[#C89B40]" data-id="element-70">
              <Calendar className="w-6 h-6" data-id="element-71" />
            </div>

            <h3 className="text-xl font-serif text-[#F5EDE0] mb-2" data-id="element-72">
              Lectura Personal
            </h3>
            <p className="text-xs text-[#d9cec0]/60 uppercase tracking-widest mb-6" data-id="element-73">
              Sesión Privada
            </p>

            <div className="flex items-baseline justify-center gap-1 mb-6" data-id="element-74">
              <span className="text-4xl font-light text-[#C89B40]" data-id="element-75">69€</span>
              <span className="text-sm text-[#d9cec0]/50" data-id="element-76">/ sesión</span>
            </div>

            <p className="text-sm text-[#d9cec0]/80 leading-relaxed mb-8 flex-grow" data-id="element-77">
              Obtén claridad sobre una situación específica. Analizaremos tu
              momento presente y las energías disponibles para tomar mejores
              decisiones.
            </p>

            <button className="w-full py-3 px-6 rounded-full bg-[#C89B40] text-[#0C0A09] border border-[#C89B40] text-sm font-semibold tracking-wide hover:bg-[#d4a855] hover:border-[#d4a855] transition-all duration-300 flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(200,155,64,0.2)] group-hover:translate-y-[-2px]" data-id="element-78">
              <span data-id="element-79">Agendar Lectura</span>
              <ArrowRight className="w-4 h-4" data-id="element-80" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}